var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChanelsLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1130,
    height: 769,
    viewBox: "0 0 1130 769",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_314_941)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_314_941)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M578.911 383.494C578.911 381.656 579.014 379.835 579.168 378.02H465.912C465.866 381.447 465.842 384.891 465.838 388.352C465.838 388.918 465.838 389.433 465.838 389.97H579.271C579.041 387.819 578.921 385.657 578.911 383.494Z",
    fill: "#3366FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.807 419.549C589.516 419.549 605.493 403.718 605.493 384.19C605.493 364.661 589.516 348.831 569.807 348.831C550.098 348.831 534.121 364.661 534.121 384.19C534.121 403.718 550.098 419.549 569.807 419.549Z",
    fill: "#3366FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.605 340.625C526.726 334.029 534.162 328.763 542.442 325.161C550.723 321.559 559.667 319.699 568.711 319.699C577.754 319.699 586.699 321.559 594.979 325.161C603.26 328.763 610.696 334.029 616.817 340.625H687.788C669.826 292.738 623.295 258.618 568.711 258.618C514.126 258.618 467.596 292.738 449.633 340.625H520.605Z",
    fill: "#003366"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.711 449.214C559.666 449.223 550.718 447.368 542.436 443.765C534.154 440.162 526.72 434.892 520.605 428.288H449.633C467.596 476.175 514.132 510.295 568.711 510.295C623.289 510.295 669.826 476.175 687.788 428.288H616.817C610.702 434.892 603.267 440.162 594.985 443.765C586.703 447.368 577.756 449.223 568.711 449.214Z",
    fill: "#003366"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.212 384.388C442.212 386.254 442.258 388.121 442.338 389.97H504.103C503.943 388.126 503.857 386.265 503.857 384.388C503.857 382.239 503.966 380.118 504.171 378.02H442.378C442.267 380.127 442.212 382.25 442.212 384.388Z",
    fill: "#3366FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.077 353.491C445.106 357.292 444.315 361.157 443.702 365.085H506.814C508.077 361.069 509.737 357.185 511.769 353.491H446.077Z",
    fill: "#3366FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.11 415.421H511.848C509.652 411.445 507.886 407.249 506.579 402.905H443.587C444.212 407.117 445.055 411.295 446.11 415.421Z",
    fill: "#3366FF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_314_941"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1130,
    height: 768,
    fill: "white",
    transform: "translate(0 0.455078)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_314_941"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 245.576,
    height: 251.677,
    fill: "white",
    transform: "translate(442.212 258.617)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChanelsLogo);
export default __webpack_public_path__ + "static/media/chanels-logo.11c10f58db0f152ffaf9c44c4f0039c2.svg";
export { ForwardRef as ReactComponent };